import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { RouterModule } from '@angular/router';
import { CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatTabsModule } from '@angular/material/tabs';
import { Observable, map, switchMap, shareReplay } from 'rxjs';
import { MainService } from 'BaseServices/main-service';
import { EquipmentDetailDTO } from 'projects/EquipmentRegistration/src/equipment-registration-base/dataTypes';
import { EquipmentInfoTabComponent } from './equipment-info-tab/equipment-info-tab.component';
import { EquipmentHomeTabComponent } from "./equipment-home-tab/equipment-home-tab.component";
import { HttpClient } from '@angular/common/http';

type TabDef = { label: string; type: 'home' | 'info' | 'docs' | 'borrow' | 'controlstatus' | 'performcontrol' };

@Component({
  selector: 'app-equipment-mobile-site',
  standalone: true,
  imports: [CommonModule,
    MatTabsModule,
    EquipmentInfoTabComponent, RouterModule, EquipmentHomeTabComponent],
  templateUrl: './equipment-mobile-site.component.html',
  styleUrl: './equipment-mobile-site.component.css',
})
export class EquipmentMobileSiteComponent implements OnInit {
  protected tabs = [
    { label: 'Home', route: './home' },
    { label: 'Info', route: './info' },
    { label: 'Docs', route: './docs' },
    { label: 'Udlån', route: './borrow' },
    { label: 'Kontrol status', route: './controlstatus' },
    { label: 'Udfør kontrol', route: './performcontrol' },
  ];

  protected selectedTabIndex = 0;

  equipment: EquipmentDetailDTO | null = null;
  loading = true;

  get activeTab(): string {
    return this.router.url.split('/').pop() || 'home';
  }
  constructor(private route: ActivatedRoute, private mainService: MainService, private router: Router,   private http: HttpClient) { }

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');

    if (token) {
      // CHANGE THIS LINE - use http.get instead of mainService.get
      this.http.get<EquipmentDetailDTO>(`/api/Equipment/ByToken?token=${token}`)
        .subscribe(eq => {
          if (eq?.id) {
            this.router.navigate(['kontrollerudstyr', eq.id]);
          }
        });
      return;
    }

    const id = Number(this.route.snapshot.paramMap.get('id'));

    if (!id || id <= 0) {
      console.error('Invalid equipment id');
      return;
    }

    this.mainService.get<EquipmentDetailDTO>('Equipment', id)
      .subscribe(eq => {
        this.equipment = eq;
      });
  }


}
